// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14HtN","type":"styles_type__139jJ","choices":"styles_choices__AYTfe"};